import React from 'react';
import { useTranslation } from 'react-i18next';
import { DiaryText } from '@/components/DiaryTextList/DiaryText';
import { BULLET_SYMBOL } from '@/utils/text';

interface Props {
  texts: string[];
  isFullText?: boolean;
  className?: string;
}

export const DiaryTextList: React.FC<Props> = ({
  texts,
  isFullText,
  className,
}) => {
  const { t } = useTranslation();
  const hasMultipleTexts = texts.length > 1;

  return (
    <div className={`flex flex-col gap-1 ${className ?? ''}`}>
      {texts.map((text, index) => (
        <div key={index} className="flex items-start gap-1">
          {hasMultipleTexts && (
            <span className="text-body-14 pt-px text-primary">
              {BULLET_SYMBOL}
            </span>
          )}
          {!!text && <DiaryText text={text} isFullText={isFullText} />}
          {!text && (
            <span className="text-body-14 flex-1">
              {t('diary.emptyDescription')}
            </span>
          )}
        </div>
      ))}
    </div>
  );
};
